
import React, { useEffect, useState } from "react";
import fetchData from "../../api/fetchApi";
import PageHeader from "../common/PageHeader";

const API_BASE_URL = "https://crm-api.chaat.ly/storage/app/";


export default function PaymentMethodsPage() {
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusLoadingId, setStatusLoadingId] = useState(null);

  const fetchMethods = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchData("finance/payment-methods");
      setMethods(data.data || []);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMethods();
  }, []);

  

  const handleToggleStatus = async (method) => {
    setStatusLoadingId(method.id);
    try {
      await fetchData(`finance/payment-methods/${method.id}/active-toggle`, "PUT", {});
      fetchMethods();
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء تحديث الحالة");
    } finally {
      setStatusLoadingId(null);
    }
  };

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title="طرق الدفع" />
      {loading && <div className="text-center mt-4">جاري التحميل...</div>}
      {error && <div className="text-red-600 text-center mt-4">{error}</div>}
      {!loading && !error && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-2">
          {methods.map((method) => (
            <PaymentMethodCard
              key={method.id}
              method={method}
              onToggleStatus={handleToggleStatus}
              statusLoading={statusLoadingId === method.id}
            />
          ))}
        </div>
      )}
    </div>
  );

}
const PaymentMethodCard = ({ method, onToggleStatus, statusLoading }) => {
  const logoUrl = method.logo?.default ? `${API_BASE_URL}${method.logo.default}` : 'https://via.placeholder.com/150';

  return (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 flex flex-col justify-between">
      <div>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-gray-800">{method.name}</h3>
          <span
            className={`px-3 py-1 text-sm rounded-full ${
              method.is_active
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {method.is_active ? "نشط" : "غير نشط"}
          </span>
        </div>
        <div className="flex justify-center mb-4">
            <img src={`${logoUrl}`} alt={`${method.name} logo`} className="h-16 object-contain" />
        </div>
        <p className="text-gray-600 mb-2">{method.description}</p>
        <div className="text-sm text-gray-500 mb-2">
          <p>
            <strong>البوابة:</strong> {method.gateway}
          </p>
          <p>
            <strong>العملة:</strong> {method.currency}
          </p>
        </div>
        <button
          className={`mt-2 px-4 py-2 rounded transition text-white ${method.is_active ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"}`}
          onClick={() => onToggleStatus(method)}
          disabled={statusLoading}
        >
          {statusLoading ? "..." : method.is_active ? "تعطيل" : "تفعيل"}
        </button>
      </div>
    </div>
  );
};